import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import AppBar from '@material-ui/core/AppBar';
// import Tabs from '@material-ui/core/Tabs';
// import Tab from '@material-ui/core/Tab';
// import SyncedProducts from 'pages/my-stores/products/SyncedProducts';
import ProductCreator from 'pages/my-stores/products/product-creator';
import {
  Container,
  ProductCreateStep,
} from 'styles/pages/my-stores/products/productSection';

// const TabPanel = (props) => {
//   const { children, value, index, ...other } = props;

//   return (
//     <div hidden={value !== index} {...other}>
//       {value === index && children}
//     </div>
//   );
// };

const useStyles = makeStyles({
  root: () => ({
    '& .MuiTab-textColorPrimary.Mui-selected': {
      color: '#000',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#000',
    },
    '& .MuiTab-wrapper': {
      fontWeight: '600',
    },
  }),
});

const ProductSection = () => {
  const classes = useStyles();
  // const [selectedTab, setSelectedTab] = useState(0);
  // const handleTabChange = (event, newValue) => setSelectedTab(newValue);

  return (
    <Container>
      <div className={classes.root}>
        {/* <AppBar className={classes.header} position='static' color='default'>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor='primary'
            textColor='primary'>
            <Tab label='Mock-Up Generator' />
            <Tab
              label='Synced Products'
              indicatorColor='primary'
              textColor='primary'
            />
          </Tabs>
        </AppBar> */}

        {/* <TabPanel value={selectedTab} index={0}> */}
        <ProductCreateStep>
          <ProductCreator />
        </ProductCreateStep>
        {/* </TabPanel> */}
        {/* <TabPanel value={selectedTab} index={1}>
          <SyncedProducts />
        </TabPanel> */}
      </div>
    </Container>
  );
};

export default ProductSection;
